export default __webpack_public_path__ + "static/designs-panel-opener-8fce1870c8a52e3740723de4f068949d.png";